import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import axios from "axios";

const SliderDiv = () => {
  const { fgColor, bgColor } = useTheme();
  const secretKey = process.env.REACT_APP_SECRET_KEY || "";
  const baseUrl = process.env.REACT_APP_SERVER_URL;

  const sliderRef = useRef(1);
  const [userId, setUserId] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(3);
  const [totalSlides, setTotalSlides] = useState(3);
  const [showLeftIcon, setShowLeftIcon] = useState(false);
  const [statsWidthClass, setStatsWidthClass] = useState("multiple-cards");
  const [livesScore, setLiveScore] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sportsData, setSportsData] = useState([]);
  const [profileData, setProfileData] = useState(null);
  const [universitiesData, setUniversitiesData] = useState([]);
  const [isCollegeLoading, setIsCollegeLoading] = useState(false);

  // Get user ID from localStorage
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?._id) {
      setUserId(user._id);
    }
  }, []);

  // Fetch scores by user ID
  useEffect(() => {
    const fetchScoresByUserId = async () => {
      if (!userId) return;

      setLoading(true);
      try {
        const token = JSON.parse(localStorage.getItem("token"))?.token || "";
        const response = await axios.get(
          `${baseUrl}/api/live-scores/fetchFilteredScores?userid=${userId}`,
          {
            headers: {
              "Content-Type": "application/json",
              "secret-key": secretKey,
              "x-auth-token": token,
            },
          }
        );

        console.log("data", response.data);
        console.log(response.data.data.length);
        setLiveScore(response.data);
      } catch (error) {
        toast.error("An error occurred while fetching scores.");
      } finally {
        setLoading(false);
      }
    };

    fetchScoresByUserId();
  }, [userId, baseUrl, secretKey]);

  const collegeList = universitiesData?.university || [];
  const matchedCollege = collegeList.find(
    (college) => college.name === profileData?.user?.school_name
  );

  const slidesToShow =
    livesScore?.user_based_scores?.length >= 3
      ? 3
      : livesScore?.user_based_scores?.length || 1;

  useEffect(() => {
    if (slidesToShow === 1) {
      setStatsWidthClass("single-card");
    } else {
      setStatsWidthClass("multiple-cards");
    }
  }, [slidesToShow]);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: slidesToShow,
    initialSlide: 0,
    prevArrow: null,
    afterChange: (current) => {
      setCurrentSlide(current);
      setShowLeftIcon(current === totalSlides - 1);
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: slidesToShow,
          slidesToScroll: slidesToShow,
          dots: true,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: slidesToShow > 2 ? 2 : slidesToShow,
          slidesToScroll: slidesToShow > 2 ? 2 : slidesToShow,
          dots: true,
          arrows: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
        },
      },
    ],
  };

  useEffect(() => {
    if (sliderRef.current && sliderRef.current.innerSlider) {
      setTotalSlides(sliderRef.current.innerSlider.props.children.length);
    }
  }, []);

  const UserschoolName = profileData?.user?.school_name || "";
  const getInitials = (name) => {
    return name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase())
      .join("");
  };
  const [expandedIndex, setExpandedIndex] = useState(-1);

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? -1 : index);
  };

  const initials = getInitials(UserschoolName);
  const sportsFileMap =
    sportsData?.sports?.reduce((acc, sport) => {
      acc[sport.name] = sport.sportsFile;
      return acc;
    }, {}) || {};

  return (
    <section style={{ maxWidth: "430px" }}>
      <div className="slider-container container-fluid slider_Maincont">
        <div>
          <div className=" ms-0 slider_maindiv slider_Maincont_slider">
            {loading || isCollegeLoading ? (
              <Skeleton width={700} height={180} />
            ) : livesScore?.data?.length > 0 ? (
              <Slider ref={sliderRef} {...settings}>
                {livesScore?.data?.map((data, index) => {
                  return (
                    <div key={index} className="Grid-maindiv">
                      <div
                        className={`card ${
                          expandedIndex === index ? "expanded" : ""
                        }`}
                        style={{ backgroundColor: bgColor, color: "#fff" }}
                        key={data.id}
                      >
                        <Row className="card-body text-left" style={{padding:"5px 10px"}}>
                          <Col xs={2} className="d-flex align-items-center">
                            <div>
                              <Image
                                src="https://cdn.pixabay.com/photo/2013/07/12/14/07/basketball-147794_1280.png"
                                alt="Sport image"
                                className="me-2"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  objectFit: "contain",
                                  objectPosition: "center",
                                }}
                                rounded
                              />
                            </div>
                          </Col>
                          <Col xs={4} className="d-flex align-items-center">
                            <p
                              className="mb-0 fw-bold"
                              style={{ fontSize: "18px" }}
                            >
                              {data?.team2?.status?.typeDescription} &nbsp;
                              {data?.team2?.status?.period}
                            </p>
                          </Col>
                          <Col
                            xs={2}
                            className="d-flex align-items-center justify-content-center"
                          >
                            <p
                              className="mb-0 text-danger fw-bold"
                              style={{ fontSize: "16px" }}
                            >
                              R
                            </p>
                          </Col>
                          <Col
                            xs={2}
                            className="d-flex align-items-center justify-content-center"
                          >
                            <p
                              className="mb-0 text-danger fw-bold"
                              style={{ fontSize: "16px" }}
                            >
                              H
                            </p>
                          </Col>
                          <Col
                            xs={2}
                            className="d-flex align-items-center justify-content-center"
                          >
                            <p
                              className="mb-0 text-danger fw-bold"
                              style={{ fontSize: "16px" }}
                            >
                              E
                            </p>
                          </Col>
                        </Row>
                        <Row className="card-body text-left " style={{padding:"5px 10px"}}>
                          <Col xs={2} className="d-flex align-items-center">
                            <div>
                              <Image
                                src={data?.team2?.logo}
                                alt="Sport image"
                                className="me-2"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  objectFit: "contain",
                                  objectPosition: "center",
                                }}
                                rounded
                              />
                            </div>
                          </Col>
                          <Col xs={4} className="d-flex align-items-center">
                            <p
                              className="mb-0 fw-bold"
                              style={{ fontSize: "18px" }}
                            >
                              {data?.team2?.name} &nbsp;
                              {data?.team2?.score}
                            </p>
                          </Col>
                          <Col
                            xs={2}
                            className="d-flex align-items-center justify-content-center"
                          >
                            <p
                              className="mb-0 fw-bold"
                              style={{ fontSize: "16px" }}
                            >
                              {data?.team2?.stats?.runs}
                            </p>
                          </Col>
                          <Col
                            xs={2}
                            className="d-flex align-items-center justify-content-center"
                          >
                            <p
                              className="mb-0  fw-bold"
                              style={{ fontSize: "16px" }}
                            >
                              {data?.team2?.stats?.hits}
                            </p>
                          </Col>
                          <Col
                            xs={2}
                            className="d-flex align-items-center justify-content-center"
                          >
                            <p
                              className="mb-0  fw-bold"
                              style={{ fontSize: "16px" }}
                            >
                              {data?.team2?.stats?.errors}
                            </p>
                          </Col>
                        </Row>
                        <Row className="card-body text-left " style={{padding:"5px 10px"}}>
                          <Col xs={2} className="d-flex align-items-center">
                            <div>
                              <Image
                                src={data?.team1?.logo}
                                alt="Sport image"
                                className="me-2"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  objectFit: "contain",
                                  objectPosition: "center",
                                }}
                                rounded
                              />
                            </div>
                          </Col>
                          <Col xs={4} className="d-flex align-items-center">
                            <p
                              className="mb-0 fw-bold"
                              style={{ fontSize: "18px" }}
                            >
                              {data?.team1?.name} &nbsp;
                              {data?.team1?.score}
                            </p>
                          </Col>
                          <Col
                            xs={2}
                            className="d-flex align-items-center justify-content-center"
                          >
                            <p
                              className="mb-0 fw-bold"
                              style={{ fontSize: "16px" }}
                            >
                              {data?.team1?.stats?.runs}
                            </p>
                          </Col>
                          <Col
                            xs={2}
                            className="d-flex align-items-center justify-content-center"
                          >
                            <p
                              className="mb-0  fw-bold"
                              style={{ fontSize: "16px" }}
                            >
                              {data?.team1?.stats?.hits}
                            </p>
                          </Col>
                          <Col
                            xs={2}
                            className="d-flex align-items-center justify-content-center"
                          >
                            <p
                              className="mb-0  fw-bold"
                              style={{ fontSize: "16px" }}
                            >
                              {data?.team1?.stats?.errors}
                            </p>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  );
                })}
              </Slider>
            ) : (
              <div className="slider_NoliveScore">
                <h5>No Live Score Data is Present</h5>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SliderDiv;
